type Listener = () => void;

const listeners = new Set<Listener>();

/** Notify home pin strip after pin / unpin from chat. */
export function notifyPinnedWidgetsChanged(): void {
  listeners.forEach((listener) => {
    try {
      listener();
    } catch (error) {
      console.error('[pinnedWidgetsBus] listener error', error);
    }
  });
}

export function subscribePinnedWidgetsChanged(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
